import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    contactAddress,
    contractCode,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    identity,
    organizationName,
    passport,
    phone,
    phone2,
    province,
    taxId2,
    ward,
  },
} = checkout;

const validation = Yup.object().shape({
  [contract.name]: Yup.string().optional(),
  [checkbox1.name]: Yup.string().optional(),
  [checkbox2.name]: Yup.string().optional(),
  [field01a.name]: Yup.number().required(field01a.errorMsg),
  [identity.name]: Yup.string().required(identity.errorMsg),
  [organizationName.name]: Yup.string().optional(),
  [authDocument.name]: Yup.string().optional(),
  [fax.name]: Yup.string().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [fax2.name]: Yup.string().optional(),
  [phone2.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone2.invalidMsg)
    .required(phone2.errorMsg),
  [contractDate.name]: Yup.string().optional(),
  [address.name]: Yup.string().required(address.errorMsg),
  [ward.name]: Yup.string().required(ward.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [passport.name]: Yup.string().required(passport.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [email2.name]: Yup.string().required(email2.errorMsg).email(email2.invalidMsg),
  [contractCode.name]: Yup.string().required(contractCode.errorMsg),
  [contactAddress.name]: Yup.string().required(contactAddress.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .optional(),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [authDocumentDate.name]: Yup.number().required(authDocumentDate.errorMsg),
  [field01b.name]: Yup.number().required(field01b.errorMsg),
  [field01c.name]: Yup.number().required(field01c.errorMsg),
  [field01d.name]: Yup.number().required(field01d.errorMsg),
});

export default validation;
